(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sledwork-preorder-request"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const container = event.target.closest('.product-details');
    const request = container?.querySelector('[data-sledwork-preorder]');
    if (!request || !event.detail) return;
    const eventProductId = event.detail.data?.productId;
    if (eventProductId && eventProductId !== request.dataset.productId) return;
    const variant = event.detail.resource;
    const short = !!variant && (variant.available === false || (!!variant.inventory_management && Number(variant.inventory_quantity) <= 0));
    request.hidden = !short;
    if (!variant) return;
    request.dataset.variantId = String(variant.id || '');
    request.dataset.variantTitle = variant.title || 'Standard';
    request.dataset.optionValues = JSON.stringify(variant.options || []);
    const title = request.querySelector('[data-preorder-variant-display]');
    const variantInput = request.querySelector('[data-preorder-variant]');
    const variantIdInput = request.querySelector('[data-preorder-variant-id]');
    if (title) title.textContent = request.dataset.variantTitle;
    if (variantInput) variantInput.value = request.dataset.variantTitle;
    if (variantIdInput) variantIdInput.value = request.dataset.variantId;
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('sledwork-preorder-request__form')) return;
    const request = form.closest('[data-sledwork-preorder]');
    if (!request || request.hidden) {
      event.preventDefault();
      return;
    }
    const names = JSON.parse(request.dataset.optionNames || '[]');
    const values = JSON.parse(request.dataset.optionValues || '[]');
    const selections = names.map((name, index) => name + ': ' + (values[index] || 'Not specified')).join('\n');
    const quantity = form.querySelector('[data-preorder-quantity]')?.value || '1';
    const message = form.querySelector('[data-preorder-notes]')?.value?.trim() || '(none)';
    const body = form.querySelector('[data-preorder-body]');
    if (!body) return;
    body.value = [
      'PRE-ORDER REQUEST - OUT OF STOCK',
      'Product: ' + (form.querySelector('[name="contact[Product]"]')?.value || ''),
      'Variant: ' + (request.dataset.variantTitle || ''),
      'Variant ID: ' + (request.dataset.variantId || ''),
      selections,
      'Quantity: ' + quantity,
      'Product URL: ' + (form.querySelector('[name="contact[Product URL]"]')?.value || ''),
      'Customer notes: ' + message
    ].filter(Boolean).join('\n');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sledwork-stock-request"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const container = event.target.closest('.product-details');
    const request = container?.querySelector('[data-sledwork-stock]');
    if (!request || !event.detail) return;
    const eventProductId = event.detail.data?.productId;
    if (eventProductId && eventProductId !== request.dataset.productId) return;
    const variant = event.detail.resource;
    const short = !!variant && (variant.available === false || (!!variant.inventory_management && Number(variant.inventory_quantity) <= 0));
    request.hidden = !short;
    if (!variant) return;
    request.dataset.variantId = String(variant.id || '');
    request.dataset.variantTitle = variant.title || 'Standard';
    request.dataset.optionValues = JSON.stringify(variant.options || []);
    const title = request.querySelector('[data-stock-variant-display]');
    const variantInput = request.querySelector('[data-stock-variant]');
    const variantIdInput = request.querySelector('[data-stock-variant-id]');
    if (title) title.textContent = request.dataset.variantTitle;
    if (variantInput) variantInput.value = request.dataset.variantTitle;
    if (variantIdInput) variantIdInput.value = request.dataset.variantId;
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('sledwork-stock-request__form')) return;
    const request = form.closest('[data-sledwork-stock]');
    if (!request || request.hidden) {
      event.preventDefault();
      return;
    }
    const names = JSON.parse(request.dataset.optionNames || '[]');
    const values = JSON.parse(request.dataset.optionValues || '[]');
    const selections = names.map((name, index) => name + ': ' + (values[index] || 'Not specified')).join('\n');
    const quantity = form.querySelector('[data-stock-quantity]')?.value || '1';
    const message = form.querySelector('[data-stock-notes]')?.value?.trim() || '(none)';
    const body = form.querySelector('[data-stock-body]');
    if (!body) return;
    body.value = [
      'STOCK ENQUIRY - OUT OF STOCK',
      'Product: ' + (form.querySelector('[name="contact[Product]"]')?.value || ''),
      'Variant: ' + (request.dataset.variantTitle || ''),
      'Variant ID: ' + (request.dataset.variantId || ''),
      selections,
      'Quantity: ' + quantity,
      'Product URL: ' + (form.querySelector('[name="contact[Product URL]"]')?.value || ''),
      'Customer notes: ' + message
    ].filter(Boolean).join('\n');
  });
  } catch(e) { console.error(e); }
})();

})();
